import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import 'styles/components/common/Navbar.scss';
import { NavLink } from 'react-router-dom';
import menuItems from 'assets/data/menuItems.json';

const Navbar = ({ moreThan768, activateMobileMenu, setActivateMobileMenu }) => {

    const navbarEl = useRef(null);
    const navbarMobileEl = document.querySelector('.mobile-menu');

    /**
     * Navbar 가 모바일용일 때, 메뉴 아이콘 클릭 시 메뉴 노출 함수
     * @returns navbarMobileEl 가 falsy 값인 경우 바로 반환
     */
    const changeMobileMenuState = () => {
        if (!navbarMobileEl) return;
        if (activateMobileMenu) {
            navbarMobileEl.classList.add('active');
        } else {
            navbarMobileEl.classList.remove('active');
        }
    }

    /**
     * Navbar 로고 클릭시 메인화면 상단으로 스크롤해주는 함수
     */
    const handleClick = () => {
        const slideEl = document.querySelector('.slide');
        slideEl && slideEl.scrollIntoView({ behavior: 'smooth' });
    }

    useEffect(() => {
        changeMobileMenuState();
    }, [activateMobileMenu]);


    return (
        <section className='Navbar' ref={navbarEl}>
            {!moreThan768 && (
                <div className='mobile-menu'>
                    <div className="mobile-menu-wrapper">
                        <div className='mobile-menu-top'>
                            <NavLink to='/' onClick={() => setActivateMobileMenu(false)}><div className='mobile-menu-top-logo' /></NavLink>
                            <div className='mobile-menu-top-icon' onClick={() => setActivateMobileMenu(false)}><FontAwesomeIcon icon={faXmark} size='2x' /></div>
                        </div>
                    </div>
                    <div className='mobile-menu-items'>
                        {menuItems.map(menu =>
                            <NavLink className={({ isActive }) => `mobile-menu-item ${isActive ? 'active' : ''}`} key={menu.id} onClick={() => setActivateMobileMenu(false)} to={menu.link}>{menu.name}</NavLink>
                        )}
                    </div>
                </div>
            )
            }
            <div className="common-menu-wrapper">
                <div className='common-menu'>
                    <NavLink to='/'><div className='common-menu-top-logo' onClick={handleClick} /></NavLink>
                    {moreThan768 &&
                        <div className='common-menu-items'>
                            {menuItems.map(menu =>
                                <NavLink className={({ isActive }) => `common-menu-item ${isActive ? 'active' : ''}`} key={menu.id} to={menu.link}>
                                    {menu.name}
                                </NavLink>
                            )}
                        </div>
                    }
                    {!moreThan768 && <div className='common-menu-top-icon' onClick={() => setActivateMobileMenu(true)}><FontAwesomeIcon icon={faBars} size='2x'></FontAwesomeIcon></div>}
                </div>
            </div>
        </section >
    );
};

export default React.memo(Navbar);